<template>
  <div class="pc_category-tab">
    <div class="category-main">
      <div class="category-title">
        <div class="title-div">{{ $t("PCCategoryTab.index") }}:</div>
      </div>
      <div class="category-right">
        <div class="category-item">
          <PC-scroll-tab
            :list="categoryList"
            :active="active"
            @handleSetActive="onTab"></PC-scroll-tab>
        </div>
        <div class="search">
          <PC-search></PC-search>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PCScrollTab from '@/components/PCScrollTab'

import PCSearch from '../PCSearch'

export default {
  name: 'PCCategoryTab',
  components: {
    PCSearch,
    PCScrollTab
  },
  props: {
    categoryList: Array
  },
  data() {
    return {
      active: 0
    };
  },
  computed: {
    categoryData() {
      return this.categoryList;
    }
  },
  methods: {
    onTab(data) {
      const { index } = data;
      this.active = index;
      this.$emit('onChange', data);
    }
  }
};
</script>

<style scoped lang="less">
.pc_category-tab {
  background-color: #fff;
  height: 72px;
  border-radius: 8px 8px 0 0;
  .category-main {
    display: flex;
    border-bottom: 1px solid #EBEBEB;
    .category-title {
      width: 140px;
      padding: 25px 0px 25px 40px;
      .title-div {
        width: 72px;
        color: #6E6E6E;
        font-size: 16px;
      }
    }
    .category-right {
      flex: 1;
      display: flex;
      .category-item {
        flex: 1;
        font-size: 16px;
      }
      .search {
        width: 360px;
      }
    }
  }
}
</style>
